(function () {
  'use strict';

  var money = window.MONO_MONEY_FORMAT || '${{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return money
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  /* ---------- paneles (bolsa y menú) ---------- */
  var overlay = document.querySelector('[data-overlay]');
  var openPanel = null;
  var lastFocus = null;

  function open(id) {
    var panel = document.querySelector('[data-panel="' + id + '"]');
    if (!panel) return;
    lastFocus = document.activeElement;
    close(true);
    panel.classList.add('is-on');
    panel.removeAttribute('aria-hidden');
    if (overlay) overlay.classList.add('is-on');
    document.body.style.overflow = 'hidden';
    openPanel = panel;
    var target = panel.querySelector('[data-close]');
    if (target) target.focus();
  }

  function close(silent) {
    document.querySelectorAll('[data-panel]').forEach(function (p) {
      p.classList.remove('is-on');
      p.setAttribute('aria-hidden', 'true');
    });
    if (overlay) overlay.classList.remove('is-on');
    document.body.style.overflow = '';
    openPanel = null;
    if (!silent && lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      open(opener.getAttribute('data-open'));
      return;
    }
    if (e.target.closest('[data-close]') || e.target.hasAttribute('data-overlay')) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanel) close();
  });

  /* ---------- bolsa ---------- */
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = '<p class="li__v" style="color:var(--muted)">Tu bolsa está vacía. Elige algo de la tienda para empezar.</p>';
      if (foot) foot.hidden = true;
      return;
    }

    var html = cart.items.map(function (item, i) {
      var src = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var img = src ? '<img src="' + src + '" alt="" loading="lazy">' : '';
      var variant = item.options_with_values && item.options_with_values.length
        ? item.options_with_values.map(function (o) { return o.value; }).join(' / ')
        : '';
      return '' +
        '<div class="li">' +
          '<a class="li__img" href="' + item.url + '">' + img + '</a>' +
          '<div>' +
            '<a class="li__n" href="' + item.url + '">' + item.product_title + '</a>' +
            (variant && variant !== 'Default Title' ? '<div class="li__v">' + variant + '</div>' : '') +
            '<div class="li__r">' +
              '<span class="li__q">' +
                '<button type="button" data-line="' + (i + 1) + '" data-to="' + (item.quantity - 1) + '" aria-label="Quitar uno">–</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-line="' + (i + 1) + '" data-to="' + (item.quantity + 1) + '" aria-label="Agregar uno">+</button>' +
              '</span>' +
              '<span>' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="li__rm" data-line="' + (i + 1) + '" data-to="0" style="margin-top:10px">Quitar</button>' +
          '</div>' +
        '</div>';
    }).join('');

    body.innerHTML = html;
    if (foot) {
      foot.hidden = false;
      var total = foot.querySelector('[data-cart-total]');
      if (total) total.textContent = formatMoney(cart.total_price);
    }
  }

  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function changeLine(line, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    changeLine(parseInt(btn.getAttribute('data-line'), 10), parseInt(btn.getAttribute('data-to'), 10))
      .catch(function () { window.location.href = window.Shopify.routes.root + 'cart'; });
  });

  /* ---------- agregar a la bolsa ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var button = form.querySelector('[data-add]');
      var label = button ? button.textContent : '';
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.textContent = 'Agregando…';
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || 'No se pudo agregar');
          return fetchCart().then(function () { open('cart'); });
        })
        .catch(function (err) {
          var slot = form.querySelector('[data-form-error]');
          if (slot) {
            slot.hidden = false;
            slot.textContent = err.message;
          }
        })
        .then(function () {
          if (button) {
            button.removeAttribute('aria-disabled');
            button.textContent = label;
          }
        });
    });
  });

  /* ---------- selector de variantes ---------- */
  document.querySelectorAll('[data-variants]').forEach(function (root) {
    var data;
    try {
      data = JSON.parse(root.querySelector('[data-variant-json]').textContent);
    } catch (err) {
      return;
    }

    var idField = root.querySelector('[data-variant-id]');
    var priceSlot = root.querySelector('[data-variant-price]');
    var button = root.querySelector('[data-add]');

    function update() {
      var chosen = Array.prototype.map.call(
        root.querySelectorAll('[data-option-index]'),
        function (group) {
          var picked = group.querySelector('input:checked');
          return picked ? picked.value : null;
        }
      );

      var match = data.filter(function (v) {
        return chosen.every(function (value, i) {
          return value === null || v.options[i] === value;
        });
      })[0];

      if (!match) return;
      if (idField) idField.value = match.id;

      if (priceSlot) {
        priceSlot.innerHTML = match.compare_at_price && match.compare_at_price > match.price
          ? formatMoney(match.price) + ' <s style="color:var(--muted);font-size:var(--t-s)">' + formatMoney(match.compare_at_price) + '</s>'
          : formatMoney(match.price);
      }

      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available ? 'Agregar a la bolsa' : 'Agotado';
      }

      if (history.replaceState && match.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) update();
    });
  });

  /* ---------- cantidad ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    box.addEventListener('click', function (e) {
      var step = e.target.closest('[data-step]');
      if (!step || !input) return;
      var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-step'), 10);
      input.value = Math.max(1, next);
    });
  });

  /* ---------- orden de colección ---------- */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }


  /* ---------- encabezado: transparente sobre la foto, negro al bajar ---------- */
  var headerObserver = null;
  function initHeader() {
    var hdr = document.querySelector('[data-header]');
    var hero = document.querySelector('.hero--over');
    if (headerObserver) { headerObserver.disconnect(); headerObserver = null; }
    if (!hdr) return;
    if (!hero || !('IntersectionObserver' in window)) {
      hdr.classList.add('is-solid');
      return;
    }
    hdr.classList.remove('is-solid');
    headerObserver = new IntersectionObserver(function (entries) {
      hdr.classList.toggle('is-solid', !entries[0].isIntersecting);
    }, { rootMargin: '-' + (hdr.offsetHeight + 1) + 'px 0px 0px 0px', threshold: 0 });
    headerObserver.observe(hero);
  }
  initHeader();
  document.addEventListener('shopify:section:load', initHeader);

  if (document.querySelector('[data-cart-body]')) fetchCart();
})();
